import React from 'react';
import PropTypes from 'prop-types';
import EmailCapture from '../../../../../components/Molecules/EmailCapture';
import { wpClassNames } from './Constants';

const toEmailCapture = () => 
{
    const Wrapper = ({ name = '', type = '', attribs = {} }) => 
    {
        if (type !== 'tag') return null;
        if (!name || name !== 'div') return null;
        const containerClassNames = attribs?.class?.split(' ') || [];
        if (!containerClassNames.includes(wpClassNames.WP_EMAIL_CAPTURE)) return null;

        return (<EmailCapture />);
    }

    Wrapper.propTypes = {
        name: PropTypes.oneOf(['div']),
        type: PropTypes.oneOf(['tag']),
        attribs: PropTypes.shape({
            class: PropTypes.string,
            id: PropTypes.string
        }),
    };

    return Wrapper;
};

export default toEmailCapture;
